import isItemView from 'owa-mail-store/lib/utils/isItemView';

export function getListViewTypeCustomData() {
    return { LVT: isItemView() ? 'I' : 'C' };
}
